__webpack_require__.p = "https://screens.dev.q-manual.net/_next/";